/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.7" stroke="#FFEAE8" strokeWidth="2.6" />
    <mask id="path-2-inside-1_19861_73012" fill="white">
      <path d="M4.64042 2.1851C4.28591 1.57106 4.49419 0.774958 5.15699 0.523119C6.39857 0.0513678 7.74488 -0.106267 9.07432 0.0741479C10.8302 0.312437 12.4573 1.12696 13.7003 2.38989C14.9432 3.65282 15.7317 5.29268 15.942 7.05215C16.1012 8.3843 15.9221 9.72792 15.4306 10.9618C15.1683 11.6205 14.369 11.8161 13.7606 11.4518C13.1523 11.0876 12.9714 10.3002 13.1831 9.62347C13.4107 8.89573 13.4841 8.12349 13.3925 7.35685C13.2497 6.16209 12.7143 5.04854 11.8703 4.19096C11.0262 3.33337 9.92136 2.78028 8.72903 2.61847C7.96395 2.51464 7.19064 2.57569 6.45936 2.79173C5.77938 2.99261 4.99494 2.79914 4.64042 2.1851Z" />
    </mask>
    <path
      d="M4.64042 2.1851C4.28591 1.57106 4.49419 0.774958 5.15699 0.523119C6.39857 0.0513678 7.74488 -0.106267 9.07432 0.0741479C10.8302 0.312437 12.4573 1.12696 13.7003 2.38989C14.9432 3.65282 15.7317 5.29268 15.942 7.05215C16.1012 8.3843 15.9221 9.72792 15.4306 10.9618C15.1683 11.6205 14.369 11.8161 13.7606 11.4518C13.1523 11.0876 12.9714 10.3002 13.1831 9.62347C13.4107 8.89573 13.4841 8.12349 13.3925 7.35685C13.2497 6.16209 12.7143 5.04854 11.8703 4.19096C11.0262 3.33337 9.92136 2.78028 8.72903 2.61847C7.96395 2.51464 7.19064 2.57569 6.45936 2.79173C5.77938 2.99261 4.99494 2.79914 4.64042 2.1851Z"
      stroke="#F03F3B"
      strokeWidth="4.8"
      mask="url(#path-2-inside-1_19861_73012)"
    />
  </svg>
);

const QuarterProgressIcon = (props) => <Icon component={svg} {...props} />;

export default QuarterProgressIcon;
